import {Injectable} from "@angular/core";
import {SavedCartService} from "@spartacus/cart/saved-cart/core";
import {GonvarriUpdateCart} from "../actions/gonvarri-update-cart.action";

@Injectable()
export class GonvarriSavedCartService extends SavedCartService {

  override saveCart({cartId, saveCartName, saveCartDescription, cloneCart }: {
    cartId: string;
    saveCartName?: string;
    saveCartDescription?: string;
    cloneCart?: boolean;
  }): void {
    this.userIdService.takeUserId(true).subscribe({
      next: (userId) => {
        return this.store.dispatch(
          new GonvarriUpdateCart({
            userId,
            cartId,
            saveCartName,
            saveCartDescription,
            cloneCart
          })
        );
      },
      error: () => {},
    });
  }

  override editSavedCart({cartId, saveCartName, saveCartDescription, cloneCart }: {
    cartId: string;
    saveCartName?: string;
    saveCartDescription?: string;
    cloneCart?: boolean;
  }): void {
    this.userIdService.takeUserId(true).subscribe({
      next: (userId) => {
        return this.store.dispatch(
          new GonvarriUpdateCart({
            userId,
            cartId,
            saveCartName,
            saveCartDescription,
            cloneCart
          })
        );
      },
      error: () => {},
    });
  }

}
